import classNames from 'classnames';
import { parseButtonFields } from '../../../utils/parseButtonFields';
import { useApplicationCallbacks } from '../../../../../../providers/application-callbacks';

export default function useSlideModalProps() {
  const callbacks = useApplicationCallbacks();

  return (modals) => {
    const [{ id }] = modals;
    const onShow = () => callbacks.markDisposableModalAsShown(id);
    const slides = modals.map((modal) => {
      const { title, description: text, image, link, id, redirect } = modal;
      const buttons = getButtons(modal);
      return { title, text: [text], img: image, link, id, redirect, buttons };
    });

    return { slides, onShow };
  };
}

function getButtons(modal) {
  const buttonData = parseButtonFields(modal);

  return buttonData.map(({ index, text }, _, { length }) => {
    const className = classNames(
      {
        0: 'custom-button_green',
        1: length === 1 ? 'custom-button_green' : 'custom-button_gray',
      }[index],
      'slide-modal__button',
    );
    const action = {
      0: modal.redirect ? (modal.redirect === 'next' ? 'next' : 'redirect') : 'toShop',
      1: 'next',
    }[index];

    return { attr: { className, text }, action };
  });
}
